// React Imports
import { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link } from 'react-router-dom';

// Third-party Imports
import classnames from 'classnames';

// Hook Imports
// import { useImageVariant } from '../hooks/useImageVariant';

// Styles Imports
import styles from './styles.module.css';

const HeroSection = () => {
  // States
  const [transform, setTransform] = useState('');

  // Hooks
  const dashboardImage = '/images/landing-page/hero-dashboard-dark3.png';

  const isAboveLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  useEffect(() => {
    const handleMouseMove = (event) => {
      const rotateX = (window.innerHeight - 2 * event.clientY) / 100;
      const rotateY = (window.innerWidth - 2 * event.clientX) / 100;

      setTransform(
        `perspective(1200px) rotateX(${rotateX < -40 ? -20 : rotateX}deg) rotateY(${rotateY}deg) scale3d(1,1,1)`
      );
    };

    // Only add event listener if window is available (on client-side)
    if (typeof window !== 'undefined') {
      window.addEventListener('mousemove', handleMouseMove);
    }

    // Cleanup function to remove the event listener
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mousemove', handleMouseMove);
      }
    };
  }, []);

  return (
    <section id="home" className="overflow-hidden pbs-[75px] -mbs-[75px] relative">
      <div
        className={classnames('relative text-center', styles.layoutSpacing)}
        style={{ transform: isAboveLgScreen ? transform : 'none' }}
      >
        <Link href="/" target="_blank" className="block relative">
          <img
            src={dashboardImage}
            alt="img"
            title="API Landing Image"
            width="100%"
            height="100%"
            loading="eager"
            className={classnames('mli-auto', styles.heroSecDashboard)}
          />
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
